import { FC } from 'react'

import withStyles from '@mui/styles/withStyles'

import { CurrencyOvalImage } from 'components/core/Acquiring/styles'
import { themeStyles } from 'themes'
import combineStyles from 'utils/combineStyles'

interface IProps {
    currencyCode: string
    leftHeader: string
    leftValue: string
    rightHeader: string
    rightValue: string
    onlyLeft?: boolean
    classes: Record<string, string>
}

const AcquiringAdditionalCards: FC<IProps> = ({ classes, leftHeader, onlyLeft, leftValue, rightHeader, rightValue, currencyCode }) => (
    <div className={classes.acquiringSettlementsAdditionalCard}>
        <div className={classes.acquiringSettlementsAdditionalCardDetails}>
            <div>
                <CurrencyOvalImage currency={currencyCode} />
            </div>
            <div>
                <div>{leftHeader}</div>
                <div>{leftValue}</div>
            </div>
        </div>
        <div className={classes.acquiringSettlementsAdditionalCardDetails}>
            {!onlyLeft && (
                <>
                    <div>
                        <CurrencyOvalImage currency={currencyCode} />
                    </div>
                    <div>
                        <div>{rightHeader}</div>
                        <div>{rightValue}</div>
                    </div>
                </>
            )}
        </div>
    </div>
)

export default withStyles(combineStyles(themeStyles.useAcquiringStyles, themeStyles.useTableStyles))(AcquiringAdditionalCards)
